import { render, staticRenderFns } from "./examDetails.vue?vue&type=template&id=8c9bf13a&scoped=true"
import script from "./examDetails.vue?vue&type=script&lang=js"
export * from "./examDetails.vue?vue&type=script&lang=js"
import style0 from "./examDetails.vue?vue&type=style&index=0&id=8c9bf13a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9bf13a",
  null
  
)

export default component.exports